import Enum from './Enum';

export default new Enum({
  1: 'Administrador(a)',
  2: 'Gerente',
  3: 'Corretor(a)',
  4: 'Funcionário(a)',
});
